import { ProxyResponse } from '../BackendApiClient/models';

export const countryCodeToFlag = (countryCode: string | undefined | null): string => {
  if (!countryCode || countryCode.length !== 2) return '🌍';
  const code = countryCode.toUpperCase();
  const offset = 0x1F1E6;
  return String.fromCodePoint(
    code.charCodeAt(0) - 65 + offset,
    code.charCodeAt(1) - 65 + offset
  );
};

const PROXY_NAME_PATTERN = /^([a-z]{2})_proxy_\d+$/;

/**
 * Extracts country code from proxy name like "bg_proxy_1770212886"
 * or from proxy URL like "brd-customer-...-zone-bg_proxy_1770212886:..."
 */
export const extractCountryCodeFromProxy = (proxy: ProxyResponse): string | null => {
  const name = getProxyLabel(proxy);
  const match = name.match(PROXY_NAME_PATTERN);
  return match ? match[1] : null;
};

/**
 * Returns the best human-readable label for a proxy:
 * 1. proxy_name if set
 * 2. zone name extracted from BrightData URL (the part after "-zone-" before ":")
 * 3. fallback to "Proxy #<id>"
 */
export const getProxyLabel = (proxy: ProxyResponse): string => {
  if (proxy.proxyName) return proxy.proxyName;

  try {
    const match = proxy.proxyUrl.match(/-zone-([^:]+)/);
    if (match) return match[1];
  } catch { /* ignore */ }

  return proxy.proxyUrl;
};

/**
 * Full display string: flag + label, e.g. "🇧🇬 bg_proxy_1770212886"
 */
export const getProxyDisplayName = (proxy: ProxyResponse): string => {
  const label = getProxyLabel(proxy);
  const cc = extractCountryCodeFromProxy(proxy);
  const flag = cc ? countryCodeToFlag(cc) : '';
  return flag ? `${flag} ${label}` : label;
};
